import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Form, InputGroup, Button } from 'react-bootstrap';
import Delete from 'components/Delete';
import { obstaclePropType } from '../props';

function Obstacles({ obstacles, tool, toolHandler, deleteShapeHandler, obstacleHeightHandler, obstacleRadiusHandler, obstacleSetbackHandler, obstacleOrientationHandler }) {
  const topRef = useRef(null);
  const bottomRef = useRef(null);

  const syncScroll = (source, target) => {
    if (target.current && source.current) {
      target.current.scrollLeft = source.current.scrollLeft;
    }
  };

  return (
    <div>
      <Row className='px-3'>
        {[['Polygon','Polygon'], ['Point','Point'], ['Keepout','Line']].map(([shapename, shape]) => (
          <Col key={shape} className='px-1'>
            <Button size="sm" className="w-100" onClick={() => toolHandler(shape)} style={{ color: tool === shape ? 'white' : 'gray' }}>
              {shapename}
            </Button>
          </Col>
        ))}
      </Row>
      <div
        className='mt-3'
        ref={topRef}
        style={{ overflowX: 'auto' }}
        onScroll={() => syncScroll(topRef, bottomRef)}
      >
        <div style={{ width: '680px', height: '1px' }} />
      </div>
      <div
        ref={bottomRef}
        style={{ overflowX: 'auto' }}
        onScroll={() => syncScroll(bottomRef, topRef)}
      >
        <div style={{ width: '680px', height: '1px' }} />
        <Row className="my-2 font-weight-bold flex-nowrap">
          <Col className="cell" style={{ minWidth: '75px' }}>#&nbsp;&nbsp;&nbsp;&nbsp;Row</Col>
          <Col className="cell">Shape</Col>
          <Col className="cell">Radius</Col>
          <Col className="cell">Height</Col>
          <Col className="cell">Setback</Col>
          <Col className="cell">Profile</Col>
          <Col className="cell" style={{ minWidth: '30px' }}></Col>
        </Row>
      {obstacles.map(({ id, shape, radius = 5, height = 12, setback = 0, orientation = "Pillar" }, index) => (
        <div>
          <Row key={id} className='flex-nowrap' style={{ height: 34 }}>
            <Col className="cell" style={{ minWidth: '75px' }}>#&nbsp;&nbsp;&nbsp;&nbsp;{index + 1}</Col>
            <Col className="cell">{shape}</Col>
            <Col className="cell">
              <InputGroup size="sm">
                <Form.Control
                  size="sm"
                  type="number"
                  placeholder={shape === 'Polygon' ? 'N/A' : 'Radius'}
                  value={shape === 'Polygon' ? 'N/A' : radius}
                  disabled={shape === 'Polygon'}
                  onChange={(e) => { obstacleRadiusHandler(index, e.target.value); }}
                />
                <InputGroup.Append>
                  <InputGroup.Text>in</InputGroup.Text>
                </InputGroup.Append>
              </InputGroup>
            </Col>
            <Col className="cell">
              <InputGroup size="sm">
                <Form.Control
                  size="sm"
                  type="number"
                  placeholder="Height"
                  value={height}
                  onChange={(e) => { obstacleHeightHandler(index, e.target.value); }}
                />
                <InputGroup.Append>
                  <InputGroup.Text>in</InputGroup.Text>
                </InputGroup.Append>
              </InputGroup>
            </Col>
            <Col className="cell">
              <InputGroup size="sm">
                <Form.Control
                  size="sm"
                  type="number"
                  placeholder="Setback"
                  value={setback}
                  onChange={(e) => { obstacleSetbackHandler(index, e.target.value); }}
                />
                <InputGroup.Append>
                  <InputGroup.Text>in</InputGroup.Text>
                </InputGroup.Append>
              </InputGroup>
            </Col>
            <Col className="cell">
              <Form.Control
                as="select"
                size="sm"
                value={orientation}
                onChange={e => obstacleOrientationHandler(index, e.target.value)}
              >
                <option value="Flat">Flat</option>
                <option value="Pillar">Pillar</option>
              </Form.Control>
            </Col>
            <Col className="cell" style={{ minWidth: '30px' }}>
              <Delete id={id} onClick={() => deleteShapeHandler(id)} />
            </Col>
          </Row>
          {/* <div class="py-1 px-2 flex">
            <Delete id={id} onClick={() => deleteShapeHandler(id)} />
          </div> */}
        </div>
      ))}
      </div>
      <style>{`
        .cell {
          padding: 0rem 0.1em;
          white-space: nowrap;
          width: 100px;
          min-width: 100px;
          overflow: hidden;
        }
      `}</style>
    </div>
  );
}

Obstacles.propTypes = {
  obstacles: obstaclePropType.isRequired,
  toolHandler: PropTypes.func.isRequired,
  obstacleRadiusHandler: PropTypes.func.isRequired,
  obstacleHeightHandler: PropTypes.func.isRequired,
  deleteShapeHandler: PropTypes.func.isRequired,
};

export default Obstacles;
